import React from 'react';
import {ReactComponent as ReplySvg} from '../../../assets/icons/repply.svg';
import {useTranslation} from "react-i18next";

const ContextMenu = ({menuData, isVisible, clickHandler}) => {
    const {t} = useTranslation();
    if (!isVisible) return null;
    return (
        <div
            style={{
                position: 'fixed',
                top: `${menuData.y}px`,
                left: `${menuData.x}px`,
                backgroundColor: 'white',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
                padding: '4px 8px 4px 4px',
                borderRadius: '8px'
            }}
        >
            <div
                style={{cursor: 'pointer', display: 'flex', alignItems: 'center', fontSize: '13px'}}
                onClick={() => clickHandler()}
            >
                <ReplySvg style={{marginRight: '4px'}}/>
                {t('all.reply')}
            </div>
        </div>
    );
};

export default ContextMenu;
